import axios from "axios";
import * as config from "./paymentConfig";
import { error, onDocumentLoad, onLoad } from "../modules/helpers";

export const getAppID = (location, country, env = "prod") => {
  const keys = config.appID[env][country.toLowerCase()];
  const configKey = Object.keys(keys).find((key) => {
    return key === location.toLowerCase();
  });

  return typeof configKey !== "undefined" ? keys[configKey] : keys["general"];
};

export const getZipString = (country) => {
  return config.zipString[country];
};

export const createSquarePaymentForm = (appID, zipString) => {
  // do {
  // setTimeout(() => {
  // let errorCount = 0;
  if (typeof SqPaymentForm !== "undefined") {
    return createForm(appID, zipString);
  }
  // errorCount += 1;
  // }, 800);
  // } while(typeof SqPaymentForm !== 'undefined' && errorCount < 10);

  // do {
  //     if (typeof SqPaymentForm !== 'undefined') {
  //         const sqPaymentForm = new SqPaymentForm({
  //             applicationId: appID,
  //             inputClass: 'sq-input',
  //             cardNumber: {
  //                 elementId: 'sq-card-number',
  //                 placeholder: "Credit Card",
  //                 inputClass: 'rounded mb-2 w-full h-12'
  //             },
  //             cvv: {
  //                 elementId: 'sq-cvv',
  //                 placeholder: 'CVV',
  //                 inputClass: 'rounded mb-2 h-12'
  //             },
  //             expirationDate: {
  //                 elementId: 'sq-expiration-date',
  //                 placeholder: 'MM/YY',
  //                 inputClass: 'rounded mb-2 h-12'
  //             },
  //             postalCode: {
  //                 elementId: 'sq-postal-code',
  //                 placeholder: zipString,
  //                 inputClass: 'rounded mb-2 w-full h-12'
  //             },
  //             inputStyles: [
  //                 {
  //                     fontSize: '15px',
  //                     padding: '10px',
  //                     backgroundColor: 'transparent',
  //                 },
  //                 {
  //                     mediaMaxWidth: '400px',
  //                     fontSize: '12px',
  //                     padding: '12px 9px 9px 9px'
  //                 }
  //             ],
  //             callbacks: {
  //                 cardNonceResponseReceived: function(errors, nonce, cardData) {

  //                     if (errors) {
  //                         // Reset all errors
  //                         // jQuery('.cvv-error span, .postalcode-error span, .date-error span, .card-error span, .card-error, .date-error, .cvv-error, .postalcode-error').slideUp();
  //                         // jQuery('#sq-cvv, #sq-postal-code, #sq-expiration-date, #sq-card-number').css({borderColor: 'inherit'});
  //                         //
  //                         const errorEl = (document.getElementById('payment-errors')) ? document.getElementById('payment-errors') : null;
  //                         errorEl.innerHTML = null;
  //                         errors.forEach( errorItem => {
  //                             error(errorEl, errorItem.message, `hidden`);
  //                         });
  //                         //
  //                         //     if (error.type == 'VALIDATION_ERROR') {
  //                         //         jQuery('#send-button-wrapper').find('.processing-transaction').remove();
  //                         //         jQuery('#send-button-wrapper a').slideDown();
  //                         //
  //                         //         if (error.field == 'expirationDate') {
  //                         //             jQuery('.date-error').find("[data-field='error-message']").text(error.message);
  //                         //             jQuery('.date-error').slideDown();
  //                         //             jQuery('.date-error span').slideDown();
  //                         //             jQuery('.date-error span').css({opacity: '1'});
  //                         //             jQuery('#sq-expiration-date').css({borderColor: '#ee2c2c'});
  //                         //         }
  //                         //
  //                         //         if (error.field == 'cardNumber') {
  //                         //             jQuery('.card-error').find("[data-field='error-message']").text(error.message);
  //                         //             jQuery('.card-error').slideDown();
  //                         //             jQuery('.card-error span').slideDown();
  //                         //             jQuery('.card-error span').css({opacity: '1'});
  //                         //             jQuery('#sq-card-number').css({borderColor: '#ee2c2c'});
  //                         //         }
  //                         //
  //                         //         if (error.field == 'cvv') {
  //                         //             jQuery('.cvv-error').find("[data-field='error-message']").text(error.message);
  //                         //             jQuery('.cvv-error').slideDown();
  //                         //             jQuery('.cvv-error span').slideDown();
  //                         //             jQuery('.cvv-error span').css({opacity: '1'});
  //                         //             jQuery('#sq-cvv').css({borderColor: '#ee2c2c'});
  //                         //         }
  //                         //
  //                         //         if (error.field == 'postalCode') {
  //                         //             jQuery('.postalcode-error').find("[data-field='error-message']").text(error.message);
  //                         //             jQuery('.postalcode-error').slideDown();
  //                         //             jQuery('.postalcode-error span').slideDown();
  //                         //             jQuery('.postalcode-error span').css({opacity: '1'});
  //                         //             jQuery('#sq-postal-code').css({borderColor: '#ee2c2c'});
  //                         //         }
  //                         //     }
  //                         //     ga('send', 'event', 'Homepage Booking', 'Payment', 'Declined - ' + error.message);
  //                         // });
  //                         return;
  //                     } else {
  //                         // Assign the value of the nonce to a hidden form element
  //                         // var nonceField = document.getElementById('card-nonce');
  //                         // nonceField.value = nonce;

  //                         // Submit the form
  //                         // processPayment(nonce, cardData);
  //                         const el = document.getElementById('card-nonce');
  //                         el.value = nonce;
  //                         el.innerText = nonce; //REPLACE ME
  //                         el.dispatchEvent(new Event('change', {bubbles: true, cancelable: true}));
  //                     }

  //                     // const changeEvent = new CustomEvent('change');
  //                     // const event = document.createEvent('HTMLEvents');
  //                     // event.initEvent('change', true, false);
  //                     return nonce;
  //                 },
  //                 unsupportedBrowserDetected: function() {
  //                     // Alert the buyer that their browser is not supported
  //                 },
  //                 inputEventReceived: function(inputEvent) {
  //                     switch (inputEvent.eventType) {
  //                         case 'focusClassAdded':
  //                             // Handle as desired
  //                             break;
  //                         case 'focusClassRemoved':
  //                             // Handle as desired
  //                             break;
  //                         case 'errorClassAdded':
  //                             // Handle as desired
  //                             break;
  //                         case 'errorClassRemoved':
  //                             // Handle as desired
  //                             break;
  //                         case 'cardBrandChanged':
  //                             // Handle as desired
  //                             break;
  //                         case 'postalCodeChanged':
  //                             // Handle as desired
  //                             break;
  //                     }
  //                 },
  //                 createPaymentRequest: function () {

  //                 }
  //             }
  //         });

  //         return sqPaymentForm;
  //     }
  //     errorCount++;
  // } while(typeof SqPaymentForm === 'undefined' && errorCount < 5);
};

const createForm = (appId, zipString) => {
  return new SqPaymentForm({
    applicationId: appId,
    inputClass: "sq-input",
    cardNumber: {
      elementId: "sq-card-number",
      placeholder: "Credit Card",
      inputClass: "rounded mb-2 w-full h-12",
    },
    cvv: {
      elementId: "sq-cvv",
      placeholder: "CVV",
      inputClass: "rounded mb-2 h-12",
    },
    expirationDate: {
      elementId: "sq-expiration-date",
      placeholder: "MM/YY",
      inputClass: "rounded mb-2 h-12",
    },
    postalCode: {
      elementId: "sq-postal-code",
      placeholder: zipString,
      inputClass: "rounded mb-2 w-full h-12",
    },
    inputStyles: [
      {
        fontSize: "15px",
        padding: "10px",
        backgroundColor: "transparent",
      },
      {
        mediaMaxWidth: "400px",
        fontSize: "12px",
        padding: "12px 9px 9px 9px",
      },
    ],
    callbacks: {
      cardNonceResponseReceived: function(errors, nonce, cardData) {
        if (errors) {
          // Reset all errors
          // jQuery('.cvv-error span, .postalcode-error span, .date-error span, .card-error span, .card-error, .date-error, .cvv-error, .postalcode-error').slideUp();
          // jQuery('#sq-cvv, #sq-postal-code, #sq-expiration-date, #sq-card-number').css({borderColor: 'inherit'});
          //
          const errorEl = document.getElementById("payment-errors")
            ? document.getElementById("payment-errors")
            : null;
          errorEl.innerHTML = null;
          errors.forEach((errorItem) => {
            error(errorEl, errorItem.message, `hidden`);
          });
          //
          //     if (error.type == 'VALIDATION_ERROR') {
          //         jQuery('#send-button-wrapper').find('.processing-transaction').remove();
          //         jQuery('#send-button-wrapper a').slideDown();
          //
          //         if (error.field == 'expirationDate') {
          //             jQuery('.date-error').find("[data-field='error-message']").text(error.message);
          //             jQuery('.date-error').slideDown();
          //             jQuery('.date-error span').slideDown();
          //             jQuery('.date-error span').css({opacity: '1'});
          //             jQuery('#sq-expiration-date').css({borderColor: '#ee2c2c'});
          //         }
          //
          //         if (error.field == 'cardNumber') {
          //             jQuery('.card-error').find("[data-field='error-message']").text(error.message);
          //             jQuery('.card-error').slideDown();
          //             jQuery('.card-error span').slideDown();
          //             jQuery('.card-error span').css({opacity: '1'});
          //             jQuery('#sq-card-number').css({borderColor: '#ee2c2c'});
          //         }
          //
          //         if (error.field == 'cvv') {
          //             jQuery('.cvv-error').find("[data-field='error-message']").text(error.message);
          //             jQuery('.cvv-error').slideDown();
          //             jQuery('.cvv-error span').slideDown();
          //             jQuery('.cvv-error span').css({opacity: '1'});
          //             jQuery('#sq-cvv').css({borderColor: '#ee2c2c'});
          //         }
          //
          //         if (error.field == 'postalCode') {
          //             jQuery('.postalcode-error').find("[data-field='error-message']").text(error.message);
          //             jQuery('.postalcode-error').slideDown();
          //             jQuery('.postalcode-error span').slideDown();
          //             jQuery('.postalcode-error span').css({opacity: '1'});
          //             jQuery('#sq-postal-code').css({borderColor: '#ee2c2c'});
          //         }
          //     }
          //     ga('send', 'event', 'Homepage Booking', 'Payment', 'Declined - ' + error.message);
          // });
          return;
        } else {
          // Assign the value of the nonce to a hidden form element
          // var nonceField = document.getElementById('card-nonce');
          // nonceField.value = nonce;

          // Submit the form
          // processPayment(nonce, cardData);
          const el = document.getElementById("card-nonce");
          el.value = nonce;
          el.innerText = nonce; //REPLACE ME
          el.dispatchEvent(
            new Event("change", { bubbles: true, cancelable: true })
          );
        }

        // const changeEvent = new CustomEvent('change');
        // const event = document.createEvent('HTMLEvents');
        // event.initEvent('change', true, false);
        return nonce;
      },
      unsupportedBrowserDetected: function() {
        // Alert the buyer that their browser is not supported
      },
      inputEventReceived: function(inputEvent) {
        switch (inputEvent.eventType) {
          case "focusClassAdded":
            // Handle as desired
            break;
          case "focusClassRemoved":
            // Handle as desired
            break;
          case "errorClassAdded":
            // Handle as desired
            break;
          case "errorClassRemoved":
            // Handle as desired
            break;
          case "cardBrandChanged":
            // Handle as desired
            break;
          case "postalCodeChanged":
            // Handle as desired
            break;
        }
      },
      createPaymentRequest: function() { },
    },
  });
};

export const processPayment = (data, cb) => {
  axios
    .post("/wp-json/badaxe/v1/payment/process", {
      location: data.location.location,
      locationName: data.location.name,
      locationAddress: data.location.address,
      groupSize: data.groupSize,
      country: data.country,
      customerName: data.customer.name,
      email: data.customer.email,
      bookDate: data.bookDate,
      customerPhone: data.customer.phone,
      nonce: data.nonce,
      verificationToken: data.verificationToken,
      promocode: data.promocode,
      fullDate: data.book.fullDate,
      emailDate: data.book.emailDate,
      players: data.book.groupsize,
      fullName: data.customer.fullName,
      firstName: data.customer.firstName,
      lastName: data.customer.lastName,
      cardBrand: data.card.brand,
      cardLast4: data.card.last4,
      groupon: data.groupon.active,
      grouponCode: data.groupon.code,
      notes: data.notes,
      addons: data.addons,
      occasion: data.extras.occasion,
      has_offer: data.has_offer,
      valid_coupon: data.valid_coupon,
      discountcode: data.discountcode,
      booking_type: data.booking_type,
      aprox_group_size: data.aprox_group_size,
      timeslot: data.book.timeslot,
      is_offer_page: data.is_offer_page,
      has_addons: data.has_addons,
      booking_type_option: data.booking_type_option,
      has_flash_sale: data.has_flash_sale,
      lanes: data.book.lanes,
      has_booking_extension: data.has_booking_extension,
      has_corkage_addon: data.has_corkage_addon,
      has_valid_groupon: data.has_valid_groupon,
      groupon_information: data.groupon_information
    })
    .then((response) => {
      cb(response.data);
    });
};

export const processLeaguePayment = (data, cb) => {
  axios
    .post("/wp-json/badaxe/v1/league-payment/process", {
      location: data.location.location,
      country: data.country,
      firstName: data.customer.firstName,
      lastName: data.customer.lastName,
      email: data.customer.email,
      phone: data.customer.phone,
      nonce: data.nonce,
      verificationToken: data.verificationToken,
      cardBrand: data.card.brand,
      cardLast4: data.card.last4,
      night1: data.night1,
      night2: data.night2,
      playerID: data.playerID,
      referrerName: data.referrerName,
      notes: data.notes,
      leagues: data.leagues,
      templateName: data.templateName,
      annualMembership: data.annualMembership,
      extraAddons: data.extraAddons
    })
    .then((response) => {
      cb(response.data);
    })
    .catch((error) => {
      let errors = [];
      let response = {
        payment: {},
      };

      if (error.response.status === 402) {
        errors.push(`Error processing the payment`);
      }

      if (error.response.status === 500) {
        errors.push(`Error processing the request`);
      }

      if (
        typeof error.response.data.errors !== "undefined" &&
        error.response.data.errors.length > 0
      ) {
        error.response.data.errors.forEach((e) => {
          errors.push(e);
        });
      }

      response.errors = errors;
      response.payment.status = "UNCOMPLETED";

      cb(response);
    });
};

export const processMarathonLeaguePayment = (data, cb) => {
  axios
    .post("/wp-json/badaxe/v1/marathon-league-payment/process", {
      location: data.location.location,
      country: data.country,
      firstName: data.customer.firstName,
      lastName: data.customer.lastName,
      email: data.customer.email,
      phone: data.customer.phone,
      nonce: data.nonce,
      verificationToken: data.verificationToken,
      cardBrand: data.card.brand,
      cardLast4: data.card.last4,
      playerID: data.playerID,
      notes: data.notes,
      quantity: data.quantity,
      leagues: data.leagues,
    })
    .then((response) => {
      cb(response.data);
    })
    .catch((error) => {
      let errors = [];
      let response = {
        payment: {},
      };

      if (error.response.status === 402) {
        errors.push(`Error processing the payment`);
      }

      if (error.response.status === 500) {
        errors.push(`Error processing the request`);
      }

      if (
        typeof error.response.data.errors !== "undefined" &&
        error.response.data.errors.length > 0
      ) {
        error.response.data.errors.forEach((e) => {
          errors.push(e);
        });
      }

      response.errors = errors;
      response.payment.status = "UNCOMPLETED";

      cb(response);
    });
};

export const processRecLeaguePayment = (data, cb) => {
  axios
    .post("/wp-json/badaxe/v1/rec-league-payment/process", {
      location: data.location.location,
      country: data.country,
      firstName: data.customer.firstName,
      lastName: data.customer.lastName,
      email: data.customer.email,
      phone: data.customer.phone,
      nonce: data.nonce,
      verificationToken: data.verificationToken,
      cardBrand: data.card.brand,
      cardLast4: data.card.last4,
      night1: data.night1,
      night2: data.night2,
      notes: data.notes,
      quantity: data.quantity,
      neverPlayedWatlLeagues: data.neverPlayedWatlLeagues,
      neverPlayedBadaxeLeagues: data.neverPlayedBadaxeLeagues,
      // leagues: data.leagues
    })
    .then((response) => {
      cb(response.data);
    })
    .catch((error) => {
      let errors = [];
      let response = {
        payment: {},
      };

      if (error.response.status === 402) {
        errors.push(`Error processing the payment`);
      }

      if (error.response.status === 500) {
        errors.push(`Error processing the request`);
      }

      if (
        typeof error.response.data.errors !== "undefined" &&
        error.response.data.errors.length > 0
      ) {
        error.response.data.errors.forEach((e) => {
          errors.push(e);
        });
      }

      response.errors = errors;
      response.payment.status = "UNCOMPLETED";

      cb(response);
    });
};

export const processBookWithoutPayment = (data, cb) => {
  axios
    .post("/wp-json/badaxe/v1/payment/process-no-payment", {
      location: data.location.location,
      locationName: data.location.name,
      locationAddress: data.location.address,
      groupSize: data.groupSize,
      country: data.country,
      customerName: data.customer.name,
      email: data.customer.email,
      bookDate: data.bookDate,
      customerPhone: data.customer.phone,
      promocode: data.promocode,
      fullDate: data.book.fullDate,
      emailDate: data.book.emailDate,
      players: data.book.groupsize,
      fullName: data.customer.fullName,
      firstName: data.customer.firstName,
      lastName: data.customer.lastName,
      groupon: data.groupon.active,
      grouponCode: data.groupon.code,
      notes: data.notes,
      addons: data.addons,
      occasion: data.extras.occasion,
      has_offer: data.has_offer,
      valid_coupon: data.valid_coupon,
      discountcode: data.discountcode,
      booking_type: data.booking_type,
      aprox_group_size: data.aprox_group_size,
      timeslot: data.book.timeslot,
      if_offer_page: data.is_offer_page,
      has_addons: data.has_addons,
      booking_type_option: data.booking_type_option,
      has_flash_sale: data.has_flash_sale,
      lanes: data.book.lanes,
      has_booking_extension: data.has_booking_extension,
      has_corkage_addon: data.has_corkage_addon,
      has_valid_groupon: data.has_valid_groupon,
      groupon_information: data.groupon_information
    })
    .then((response) => {
      cb(response.data);
    });
};


export const processWalkinBookingPayment = (data, cb) => {
  axios
    .post("/wp-json/badaxe/v1/payment/process-walkin-booking", {
      location: data.location,
      locationName: data.locationName,
      admissions: data.admissions,
      group: data.admissions,
      timeslot: data.timeslot,
      type: data.type,
      duration: data.duration,
      nonce: data.nonce,
      verificationToken: data.verificationToken,
      cardBrand: data.cardBrand,
      cardLast4: data.cardLast4,
      fullName: data.fullName,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone,
      totalDue: data.totalDue,
      date: data.date,
      has_valid_groupon: data.has_valid_groupon,
      groupon_information: data.groupon_information
    })
    .then((response) => {
      cb(response.data);
    });
};

export const processWalkinBookingWithoutPayment = (data, cb) => {
  axios
    .post("/wp-json/badaxe/v1/payment/process-walkin-booking-no-payment", {
      location: data.location,
      locationName: data.locationName,
      admissions: data.admissions,
      timeslot: data.timeslot,
      type: data.type,
      duration: data.duration,
      nonce: data.nonce,
      verificationToken: data.verificationToken,
      cardBrand: data.cardBrand,
      cardLast4: data.cardLast4,
      fullName: data.fullName,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone,
      totalDue: data.totalDue,
      date: data.date,
      has_valid_groupon: data.has_valid_groupon,
      groupon_information: data.groupon_information
    })
    .then((response) => {
      cb(response.data);
    });
};

// const axios = require('axios');
//
// var book = require("./book.js");
//
// var zipString = '';
// var appId = '';
// var env = '';
// var sqPaymentForm = '';
// var giftCard = '';
// var groupon = null;
//
// var setEnv = (currentEnv) => {
//     env = currentEnv;
// };
//
// var getEnv = () => {
//     return env;
// };
//
// var setAppId = (id) => {
//     appId = id;
// };
//
// var getAppId = () => {
//     return appId;
// };
//
// var setZipString = (selectString) => {
//     zipString = selectString;
// };
//
// var getZipString = () => {
//     return zipString;
// };
//
// var setGiftCard = (selectGiftcard) => {
//     giftCard = selectGiftcard;
// };
//
// var getGiftCard = () => {
//     return giftCard;
// };
//
// var init = () => {
//
//     setEnv(0);
//
//     var country     = book.getPaymentCountry();
//     var location    = book.getLocation();
//
//     if ('ca' == country) {
//         if ( getEnv() == 0 ) {
//             if (book.getLocation().toLowerCase() !== 'windsor') {
//                 setAppId('sq0idp-76vXZfW_PoY0eIDrE1pbuQ');
//             } else {
//                 setAppId('sq0idp-pzxugO-V2ufFNonw-mm63A');
//             }
//         } else {
//             if (book.getLocation().toLowerCase() !== 'windsor') {
//                 setAppId('sandbox-sq0idb-r5C1zqzuoSKiu32AHq-WUA');
//             } else {
//                 setAppId('sandbox-sq0idb-r5C1zqzuoSKiu32AHq-WUA');
//             }
//         }
//
//         setZipString('Postal Code');
//     } else if ('us' == country) {
//         if ( getEnv() == 0 ) {
//             if (book.getLocation().toLowerCase() === 'nashville') {
//                 setAppId('sq0idp-AGkUmGj973RteTRLsBY2mA');
//             } else if (book.getLocation().toLowerCase() === 'frisco') {
//                 setAppId('sq0idp-EkexFHgDgURBVmkthebwdQ');
//             } else {
//                 setAppId('sq0idp-mmBUhNpNa0t5fHDJRVPDlA');
//             }
//         } else {
//             if (book.getLocation().toLowerCase() === 'nashville') {
//                 setAppId('sandbox-sq0idb-eMMUH2wn5aLEcbU6t_N3sw');
//             } else if (book.getLocation().toLowerCase() == 'frisco') {
//                 setAppId('sandbox-sq0idb-pzmztR9cVG1UPTcdSGkfFQ');
//             } else {
//                 setAppId('sandbox-sq0idb-r5C1zqzuoSKiu32AHq-WUA');
//             }
//         }
//         setZipString('ZIP Code');
//     } else {
//         if ( getEnv() == 0 ) {
//             setAppId('sq0idp-yhei2Eg72CofXgD2IA5CCw');
//         } else {
//             // setAppId('sandbox-sq0idp-yhei2Eg72CofXgD2IA5CCw');
//             setAppId('sandbox-sq0idb-r5C1zqzuoSKiu32AHq-WUA');
//         }
//         setZipString('ZIP Code');
//     }
//
//     setGiftCard(false);
//     createSqPaymentForm();
//     buildForm();
// };
//
//
// var createSqPaymentForm = () => {
//
//     sqPaymentForm = new SqPaymentForm({
//         applicationId: getAppId(),
//         inputClass: 'sq-input',
//         cardNumber: {
//             elementId: 'sq-card-number',
//             // placeholder: "0000 0000 0000 0000",
//             placeholder: "Credit Card",
//             inputClass: 'book__form--input'
//         },
//         cvv: {
//             elementId: 'sq-cvv',
//             placeholder: 'CVV'
//         },
//         expirationDate: {
//             elementId: 'sq-expiration-date',
//             placeholder: 'MM/YY'
//         },
//         postalCode: {
//             elementId: 'sq-postal-code',
//             placeholder: getZipString()
//         },
//         inputStyles: [
//             {
//                 fontSize: '15px',
//                 padding: '10px',
//                 backgroundColor: 'transparent',
//             },
//             {
//                 mediaMaxWidth: '400px',
//                 fontSize: '12px',
//                 padding: '12px 9px 9px 9px'
//             }
//         ],
//         callbacks: {
//             cardNonceResponseReceived: function(errors, nonce, cardData) {
//
//                 if (errors) {
//
//                     // Reset all errors
//                     jQuery('.cvv-error span, .postalcode-error span, .date-error span, .card-error span, .card-error, .date-error, .cvv-error, .postalcode-error').slideUp();
//                     jQuery('#sq-cvv, #sq-postal-code, #sq-expiration-date, #sq-card-number').css({borderColor: 'inherit'});
//
//                     errors.forEach(function(error) {
//
//                         if (error.type == 'VALIDATION_ERROR') {
//                             jQuery('#send-button-wrapper').find('.processing-transaction').remove();
//                             jQuery('#send-button-wrapper a').slideDown();
//
//                             if (error.field == 'expirationDate') {
//                                 jQuery('.date-error').find("[data-field='error-message']").text(error.message);
//                                 jQuery('.date-error').slideDown();
//                                 jQuery('.date-error span').slideDown();
//                                 jQuery('.date-error span').css({opacity: '1'});
//                                 jQuery('#sq-expiration-date').css({borderColor: '#ee2c2c'});
//                             }
//
//                             if (error.field == 'cardNumber') {
//                                 jQuery('.card-error').find("[data-field='error-message']").text(error.message);
//                                 jQuery('.card-error').slideDown();
//                                 jQuery('.card-error span').slideDown();
//                                 jQuery('.card-error span').css({opacity: '1'});
//                                 jQuery('#sq-card-number').css({borderColor: '#ee2c2c'});
//                             }
//
//                             if (error.field == 'cvv') {
//                                 jQuery('.cvv-error').find("[data-field='error-message']").text(error.message);
//                                 jQuery('.cvv-error').slideDown();
//                                 jQuery('.cvv-error span').slideDown();
//                                 jQuery('.cvv-error span').css({opacity: '1'});
//                                 jQuery('#sq-cvv').css({borderColor: '#ee2c2c'});
//                             }
//
//                             if (error.field == 'postalCode') {
//                                 jQuery('.postalcode-error').find("[data-field='error-message']").text(error.message);
//                                 jQuery('.postalcode-error').slideDown();
//                                 jQuery('.postalcode-error span').slideDown();
//                                 jQuery('.postalcode-error span').css({opacity: '1'});
//                                 jQuery('#sq-postal-code').css({borderColor: '#ee2c2c'});
//                             }
//                         }
//                         ga('send', 'event', 'Homepage Booking', 'Payment', 'Declined - ' + error.message);
//                     });
//                 } else {
//                     // Assign the value of the nonce to a hidden form element
//                     var nonceField = document.getElementById('card-nonce');
//                     nonceField.value = nonce;
//
//                     // Submit the form
//                     // if ( getGiftCard() == true ){
//                     //     processGiftCardPayment(nonce, cardData);
//                     // } else {
//                     //     processPayment(nonce, cardData);
//                     // }
//
//                     // Submit the form
//                     processPayment(nonce, cardData);
//                 }
//             },
//             unsupportedBrowserDetected: function() {
//                 // Alert the buyer that their browser is not supported
//             },
//             inputEventReceived: function(inputEvent) {
//                 switch (inputEvent.eventType) {
//                     case 'focusClassAdded':
//                         // Handle as desired
//                         break;
//                     case 'focusClassRemoved':
//                         // Handle as desired
//                         break;
//                     case 'errorClassAdded':
//                         // Handle as desired
//                         break;
//                     case 'errorClassRemoved':
//                         // Handle as desired
//                         break;
//                     case 'cardBrandChanged':
//                         // Handle as desired
//                         break;
//                     case 'postalCodeChanged':
//                         // Handle as desired
//                         break;
//                 }
//             }
//         }
//     });
//
// };
//
// var buildForm = () => {
//     // Build the form
//     sqPaymentForm.build();
// };
//
// var getGroupon = () => {
//     return groupon;
// };
//
//
// var submitForm = (event) => {
//
//     if (book.getGroupon() !== null) {
//         // Send the form without check for the giftcard
//         // Submit the form
//         var nonce    = null;
//         var cardData = null;
//
//         processPayment(nonce, cardData);
//     } else { //Check the credit card
//         sqPaymentForm.requestCardNonce();
//     }
// };
//
//
// var processPayment = (nonce, cardData) => {
//
//     var formData = new FormData;
//     // Data for payments
//     formData.append('action', 'book_payment');
//     formData.append('location', book.getPaymentLocation());
//     formData.append('locationName', book.getLocation());
//     formData.append('locationAddress', window._config.locations[book.getLocation().toLowerCase()].address);
//     formData.append('group_size', book.getGroupSize());
//     formData.append('location_country', book.getPaymentCountry());
//     formData.append('name', book.getFullName());
//     formData.append('email', book.getEmail());
//     formData.append('book_date', book.getFullDate());
//     formData.append('phone', book.getPhone());
//     formData.append('nonce', nonce);
//     formData.append('with_item', book.getItem());
//     formData.append('promocode', book.getPromocode());
//     formData.append('with_tshirt', book.getShirt());
//     formData.append('tshirt_size', book.getShirtSize());
//
//     // Data for books
//     formData.append('full_date', book.getFullDate());
//     formData.append('email_date', book.getFullDate());
//     formData.append('players', book.getGroupSize());
//     formData.append('first_name', book.getFirstName());
//     formData.append('last_name', book.getLastName());
//
//     if (cardData !== null) {
//         formData.append('card_brand', cardData.card_brand);
//         formData.append('last_4', cardData.last_4);
//     } else {
//         formData.append('card_brand', null);
//         formData.append('last_4', null);
//         formData.append('groupon', 'true');
//         formData.append('grouponCode', book.getGroupon());
//     }
//
//     // Show processing screen
//     var processScreen           = document.getElementById('book-module-process-wrapper');
//     var processingScreen        = document.getElementById('book-module-processing');
//     var confirmationScreen      = document.getElementById('book-module-confirmation');
//
//     processScreen.style.display = 'none';
//     processingScreen.style.display = 'block';
//
//     jQuery("html, body").animate({
//         scrollTop: jQuery("#book-module-processing").offset().top - 200
//     }, 1000, 'easeOutExpo');
//
//     axios.post(ajaxurl, formData)
//         .then(function(response) {
//
//             if (response.data.result == true) {
//                 processingScreen.style.display = 'none';
//
//                 // Populate Information for confirmation Screen
//                 confirmationScreen.querySelector('#confirmation-reference').textContent = response.data.reference;
//                 confirmationScreen.querySelector('#confirmation-location').textContent  = book.getLocation();
//                 confirmationScreen.querySelector('#confirmation-date').textContent      = book.getBookedDateShow();
//                 confirmationScreen.querySelector('#confirmation-time').textContent      = book.getTimeslot();
//                 confirmationScreen.querySelector('#confirmation-groupsize').textContent = book.getGroupSize();
//                 confirmationScreen.querySelector('#confirmation-name').textContent      = book.getFullName();
//                 confirmationScreen.querySelector('#confirmation-email').textContent     = book.getEmail();
//                 confirmationScreen.querySelector('#confirmation-phone').textContent     = book.getPhone();
//                 confirmationScreen.querySelector('#confirmation-company').textContent   = book.getCompany();
//                 confirmationScreen.querySelector('#confirmation-promocode').textContent = book.getPromocode();
//
//                 confirmationScreen.style.display = 'block';
//                 book.setSource('email');
//                 book.setCompleted(true);
//
//                 ga('send', 'event', 'Homepage Booking', 'Payment', 'Completed');
//
//                 jQuery("html, body").animate({
//                     scrollTop: jQuery("#book-module-confirmation").offset().top - 200
//                 }, 1000, 'easeOutExpo');
//             } else {
//                 processingScreen.style.display = 'none';
//                 processScreen.style.display = 'block';
//
//                 var result = JSON.parse(response.data);
//                 var errors = result.errors;
//
//                 // Reset all errors
//                 jQuery('.general-error span, .general-error').slideUp();
//
//                 errors.forEach(function(error) {
//                     var message = null;
//
//                     switch (error.code) {
//                         case 'NOT_FOUND':
//                             message = 'Credit Card Declined';
//                             break;
//                         case 'CARD_EXPIRED':
//                             message = 'The card issuer declined the request because the card is expired';
//                             break;
//                         case 'PAN_FAILURE':
//                             message = 'The specified card number is invalid';
//                             break;
//                         case 'INSUFFICIENT_FUNDS':
//                             message = 'The payment source has insufficient funds to cover the payment';
//                             break;
//                         case 'CVV_FAILURE':
//                             message = 'Invalid CVV';
//                             break;
//                         default:
//                             message = 'There was an error. Please try again';
//                             break;
//                     }
//
//                     jQuery('.general-error').find("[data-field='error-message']").text(message);
//                     jQuery('.general-error').slideDown();
//                     jQuery('.general-error span').slideDown();
//                     jQuery('.general-error span').css({opacity: '1'});
//
//                     setTimeout(function() {
//                         jQuery('.general-error span, .general-error').slideUp();
//                     }, 5000);
//
//                     ga('send', 'event', 'Homepage Booking', 'Payment', 'Declined - ' + message);
//                 });
//
//                 ga('send', 'event', 'Homepage Booking', 'Payment', 'Declined');
//
//                 jQuery("html, body").animate({
//                     scrollTop: jQuery("#book-module-process-wrapper").offset().top - 200
//                 }, 1000, 'easeOutExpo');
//             }
//         })
//         .catch(function(error) {
//             console.log('Error: ', error);
//         });
//
// };
//
// module.exports = {
//     init,
//     submitForm
// };
